import isNil from 'lodash/isNil';

import { StepCategory, type AppData } from '../../../types/app_data';
import type { Step } from '../../types/step';

export const GarageOnlyReminder: Step = {
  id: 'garageonlyreminder',
  pathname: '/garageonlyreminder',
  canShow: (appData: AppData) => {
    return true;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    return !isNil(appData.maintenanceAccepted);
  },
  category: () => StepCategory.GarageOnlyServices,
};
